import React, { useEffect, useState } from "react";
import { makeStyles, useTheme } from "@mui/styles";
import { CircularProgress, Grid, IconButton, MenuItem } from "@mui/material";
import Sidebar from "../../../../ui/sidebar/Sidebar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { combineValidators, isRequired } from "revalidate";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import TextInput from "../../../../common/form/TextInput";
import TextArea from "../../../../common/form/TextArea";
import { useHistory } from "react-router-dom";
import DatePickerInput from "../../../../common/form/DatePickerInput";
import StateLookup from "../../../../ui/forms/formLookups/StateLookup";
import SelectInput from "../../../../common/form/SelectInput";
import InstitutionProgramForm from "./InstitutionProgramForm";
import { fetchAllPrograms } from "../../../../store/actions/adminActions/programActions/adminProgramActions";
import { addNewInstitution } from "../../../../store/actions/adminActions/institutionActions/adminInstitutionActions";
import Avatar from "@mui/material/Avatar";
import DropzoneInput from "../../../../ui/dropzone/DropzoneInput";
import CheckboxInput from "../../../../common/form/CheckboxInput";
import { Cancel } from "@mui/icons-material";

const useStyles = makeStyles((theme) => ({
  button: {
    marginLeft: "0.4em",
  },
  fieldWrapper: {
    paddingTop: "0.4em",
    paddingBottom: "0.4em",
  },
  icon: {
    fontSize: "3em",
    color: theme.palette.common.textGrey,
  },

  dropzone: {
    width: 200,
    height: 160,
  },
  image: {
    width: 160,
    height: 160,
  },
}));

const validate = combineValidators({
  institutionName: isRequired({ message: "Name is required" }),
  institutionAddress1: isRequired({ message: "Address 1 is required" }),
  institutionCity: isRequired({ message: "City is required" }),
  institutionState: isRequired({ message: "State is required" }),
  institutionZipCode: isRequired({ message: "Zip Code is required" }),
  institutionCohort: isRequired({ message: "Cohort is required" }),
  arrivalDate: isRequired({ message: "Date is required" }),
  departureDate: isRequired({ message: "Date is required" }),
});

const actions = {
  fetchAllPrograms,
  addNewInstitution,
};

const mapStateToProps = (state) => {
  let programs = [];

  if (
    state.adminPrograms.allPrograms &&
    state.adminPrograms.allPrograms.length > 0
  ) {
    programs = state.adminPrograms.allPrograms;
  }

  return {
    programs,
    loading: state.loading.loading,
  };
};

const AdminNewInstitution = ({
  addNewInstitution,
  fetchAllPrograms,
  programs,
  handleSubmit,
  loading,

  submitting,
}) => {
  const classes = useStyles();
  const theme = useTheme();

  const states = StateLookup.states;

  const history = useHistory();

  useEffect(() => {
    fetchAllPrograms();
  }, [fetchAllPrograms]);

  const [uploadImage, setUploadImage] = useState(false);
  const [avatarImage, setAvatarImage] = useState(false);
  const [uploadMap, setUploadMap] = useState(false);
  const [mapImage, setMapImage] = useState(false);
  const [programPacket, setProgramPacket] = useState(false);

  const defaultImageURL =
    "data:image/png;base64,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";
  const handleCreateInstitution = async (values) => {
    await addNewInstitution(values, avatarImage, mapImage, programPacket);
    history.push("/admin/settings/institutions");
  };
  return (
    <Grid container>
      <Grid item md={2}>
        <Sidebar />
      </Grid>

      <Grid item md={10} style={{ paddingLeft: "1.5em" }}>
        <Grid item container direction={"column"}>
          <Grid item>
            <Typography variant={"h4"}>Create Institution</Typography>
          </Grid>
          <Grid
            container
            item
            alignItems={"center"}
            style={{ marginTop: "0.5em", marginBottom: "1em" }}
          >
            {!uploadImage && (
              <>
                {!loading && (
                  <Grid item>
                    <Avatar
                      variant={"square"}
                      src={defaultImageURL}
                      style={{ width: "160px", height: "160px" }}
                    />
                  </Grid>
                )}
                {loading && (
                  <Grid item>
                    <CircularProgress color={"primary"} />
                  </Grid>
                )}
                <Grid item>
                  <Button
                    size={"small"}
                    disabled={loading}
                    variant={"outlined"}
                    color={"primary"}
                    className={classes.button}
                    style={{ width: "140px" }}
                    onClick={() => setUploadImage(true)}
                  >
                    Add Logo
                  </Button>
                </Grid>
              </>
            )}
            {uploadImage && (
              <>
                <Grid item className={classes.dropzone}>
                  {!avatarImage && <DropzoneInput setFiles={setAvatarImage} />}
                  {avatarImage && (
                    <img
                      className={classes.image}
                      src={avatarImage[0].preview}
                      alt="uploaded avatar"
                    />
                  )}
                </Grid>

                <Grid item>
                  <Grid item container direction={"column"}>
                    <Grid item style={{ marginTop: "0.5em" }}>
                      <Button
                        size={"small"}
                        variant={"outlined"}
                        style={{
                          color: theme.palette.error.main,
                          borderColor: theme.palette.error.main,
                          width: "140px",
                        }}
                        className={classes.button}
                        onClick={() => {
                          setUploadImage(false);
                          setAvatarImage(false);
                        }}
                      >
                        Cancel
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </>
            )}
            {!uploadMap && (
              <>
                {!loading && (
                  <Grid item>
                    <Avatar
                      variant={"square"}
                      src={defaultImageURL}
                      style={{ width: "160px", height: "160px" }}
                    />
                  </Grid>
                )}
                {loading && (
                  <Grid item>
                    <CircularProgress color={"primary"} />
                  </Grid>
                )}

                <Grid item>
                  <Grid item container direction={"column"}>
                    <Grid item>
                      <Button
                        size={"small"}
                        disabled={loading}
                        variant={"outlined"}
                        color={"primary"}
                        className={classes.button}
                        style={{ width: "140px" }}
                        onClick={() => setUploadMap(true)}
                      >
                        Add Map
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </>
            )}
            {uploadMap && (
              <>
                <Grid item className={classes.dropzone}>
                  {!mapImage && <DropzoneInput setFiles={setMapImage} />}
                  {mapImage && (
                    <img
                      className={classes.image}
                      src={mapImage[0].preview}
                      alt="uploaded avatar"
                    />
                  )}
                </Grid>

                <Grid item>
                  <Grid item container direction={"column"}>
                    <Grid item style={{ marginTop: "0.5em" }}>
                      <Button
                        size={"small"}
                        variant={"outlined"}
                        style={{
                          color: theme.palette.error.main,
                          borderColor: theme.palette.error.main,
                          width: "140px",
                        }}
                        className={classes.button}
                        onClick={() => {
                          setUploadMap(false);
                          setMapImage(false);
                        }}
                      >
                        Cancel
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </>
            )}
          </Grid>

          <form
            autoComplete={"off"}
            onSubmit={handleSubmit(handleCreateInstitution)}
          >
            <Grid item style={{ width: "50%" }}>
              <Grid item container direction={"column"}>
                <Grid item className={classes.fieldWrapper}>
                  <Field
                    name={"institutionName"}
                    label={"Institution Name"}
                    component={TextInput}
                    type={"text"}
                    variant={"outlined"}
                  />
                </Grid>
                <Grid item className={classes.fieldWrapper}>
                  <Field
                    name={"institutionAddress1"}
                    label={"Address 1"}
                    component={TextInput}
                    type={"text"}
                    variant={"outlined"}
                  />
                </Grid>
                <Grid item className={classes.fieldWrapper}>
                  <Field
                    name={"institutionAddress2"}
                    label={"Address 2"}
                    component={TextInput}
                    type={"text"}
                    variant={"outlined"}
                  />
                </Grid>
                <Grid item className={classes.fieldWrapper}>
                  <Field
                    name={"institutionCity"}
                    label={"City"}
                    component={TextInput}
                    type={"text"}
                    variant={"outlined"}
                  />
                </Grid>
                <Grid item className={classes.fieldWrapper}>
                  <Field
                    name={"institutionState"}
                    label={"State"}
                    component={SelectInput}
                    type={"text"}
                    variant={"outlined"}
                  >
                    {states.map((state) => (
                      <MenuItem key={state.value} value={state.text}>
                        {state.text}
                      </MenuItem>
                    ))}
                  </Field>
                </Grid>
                <Grid item className={classes.fieldWrapper}>
                  <Field
                    name={"institutionZipCode"}
                    label={"Zip"}
                    component={TextInput}
                    type={"text"}
                    variant={"outlined"}
                  />
                </Grid>
                <Grid item className={classes.fieldWrapper}>
                  <Field
                    name={"institutionPhone"}
                    label={"Phone"}
                    component={TextInput}
                    type={"text"}
                    variant={"outlined"}
                  />
                </Grid>
                <Grid item className={classes.fieldWrapper}>
                  <Field
                    name={"institutionEmail"}
                    label={"Email"}
                    component={TextInput}
                    type={"text"}
                    variant={"outlined"}
                  />
                </Grid>
                <Grid item className={classes.fieldWrapper}>
                  <Field
                    name={"institutionWeb"}
                    label={"Web"}
                    component={TextInput}
                    type={"text"}
                    variant={"outlined"}
                  />
                </Grid>
                <Grid item className={classes.fieldWrapper}>
                  <Field
                    name={"arrivalDate"}
                    label={"Arrival Date"}
                    component={DatePickerInput}
                    type={"text"}
                    inputVariant={"outlined"}
                    size={"small"}
                    style={{ width: "100%" }}
                  />
                </Grid>
                <Grid item className={classes.fieldWrapper}>
                  <Field
                    name={"departureDate"}
                    label={"Departure Date"}
                    component={DatePickerInput}
                    type={"text"}
                    inputVariant={"outlined"}
                    size={"small"}
                    style={{ width: "100%" }}
                  />
                </Grid>
                <Grid item className={classes.fieldWrapper}>
                  <Field
                    name={"institutionNotes"}
                    label={"Institution Notes"}
                    component={TextArea}
                    rows={5}
                    type={"text"}
                    variant={"outlined"}
                  />
                </Grid>

                <Grid item className={classes.fieldWrapper}>
                  <Field
                    name={"institutionCohort"}
                    label={"Institution Cohort"}
                    component={TextInput}
                    type={"text"}
                    variant={"outlined"}
                  />
                </Grid>

                <Grid item className={classes.fieldWrapper}>
                  <Typography>Program Packet</Typography>
                  {!programPacket && (
                    <DropzoneInput setFiles={setProgramPacket} />
                  )}
                  {programPacket && (
                    <Grid container alignItems="center">
                      <Typography>{programPacket[0].name}</Typography>
                      <IconButton
                        onClick={() => setProgramPacket(null)}
                        color="secondary"
                        size="small"
                      >
                        <Cancel />
                      </IconButton>
                    </Grid>
                  )}
                </Grid>

                <Grid
                  item
                  container
                  alignItems="center"
                  justifyContent="space-between"
                  className={classes.fieldWrapper}
                >
                  <Typography>Virtual</Typography>
                  <Field
                    name={"virtual"}
                    component={CheckboxInput}
                    size="medium"
                    color="secondary"
                  />
                </Grid>

                <InstitutionProgramForm programs={programs} />

                {/*BUTTONS*/}
                <Grid item style={{ marginLeft: "auto" }}>
                  <Button
                    variant={"outlined"}
                    color={"primary"}
                    className={classes.button}
                    type={"submit"}
                    disabled={submitting}
                  >
                    Create Institution
                  </Button>

                  <Button
                    variant={"outlined"}
                    color={"secondary"}
                    className={classes.button}
                    onClick={() => history.push("/admin/settings/institutions")}
                  >
                    Cancel
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default connect(
  mapStateToProps,
  actions
)(reduxForm({ form: "createInstitution", validate })(AdminNewInstitution));
